import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { faqData } from '@/mocks/anime';

export default function FAQSection() {
  const { t } = useTranslation();
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            {t('section.faq')}
          </h2>
          <p className="text-sm md:text-base text-foreground-600">
            {t('section.faq.desc')}
          </p>
        </div>

        <div className="flex flex-col gap-3">
          {faqData.map((faq, index) => (
            <div
              key={index}
              className="bg-background-50 rounded-lg border border-background-200/70 overflow-hidden"
            >
              <button
                className="w-full flex items-center justify-between gap-4 p-4 md:p-5 text-left cursor-pointer"
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
              >
                <span className="text-sm md:text-base font-medium text-foreground-900 pr-2">
                  {faq.question}
                </span>
                <div className="w-5 h-5 flex items-center justify-center flex-shrink-0">
                  <i
                    className={`text-foreground-500 transition-transform duration-300 text-lg ${
                      openIndex === index ? 'ri-subtract-line' : 'ri-add-line'
                    }`}
                  ></i>
                </div>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === index ? 'max-h-[500px] opacity-100' : 'max-h-0 opacity-0'
                }`}
              >
                <p className="px-4 md:px-5 pb-4 md:pb-5 text-sm text-foreground-600 leading-relaxed">
                  {faq.answer}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}